/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import msgpack5 from 'msgpack5'
import { Endpoints, fetch, normalizeKeys, post, put } from '../api'
import { AxiosError } from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { IReportBlueprint } from '../decoders/blueprintDecoder'
import { useCallback, useState } from 'react'
import rootStore from '../../store/RootStore'

const msgpack = msgpack5()

/**
 * If you want to use the wizardAPI, you need to import it first:
 * @param sourceId
 * @returns {Promise<IReportBlueprint>}
 */
export const getReportSourceById = async (
  sourceId: string,
): Promise<IReportBlueprint> => {
  const uri = `${Endpoints.Wizard}/${sourceId}/Blueprint`
  const response = await fetch(uri)

  return normalizeKeys(response.data)
}

/**
 *
 * @param sourceId
 * @param reportSource
 */
export const putReportSourceById = async (
  sourceId: string,
  reportSource: IReportBlueprint,
) => {
  const uri = `${Endpoints.Wizard}/${sourceId}/Blueprint`

  const data = await put(uri, reportSource, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (!data) throw new AxiosError('No data returned from api')
  return data
}

export const generateReportSourceById = async (sourceId: string) => {
  const uri = `${Endpoints.Wizard}/${sourceId}`

  const data = await post(uri, null, {
    headers: {
      'Content-Type': 'application/x-msgpack',
    },
  })
    .then(response => {
      return response
    })
    .catch(e => {
      console.error(e)
    })

  if (!data) throw new AxiosError('No data returned from api')
  return data
}

// function downloadBlueprint(blueprintName, reportSource) {
//   const newBlueprint = [...reportSource]
//   newBlueprint[1] = blueprintName
//   const newBlueprintId = uuidv4()
//   const modifiedBlueprint = replaceId(
//     newBlueprint,
//     newBlueprint[0],
//     newBlueprintId,
//   )
//
//   const newBlueprintMsgpack = msgpack.encode(modifiedBlueprint)
//
//   /* Download file */
//   {
//     const url = window.URL.createObjectURL(new Blob([newBlueprintMsgpack]))
//     const link = document.createElement('a')
//     link.href = url
//     link.setAttribute('download', `${newBlueprintId}.msgpack`)
//
//     // Append to html link element page
//     document.body.appendChild(link)
//
//     // Start download
//     link.click()
//
//     // Clean up and remove the link
//     link?.parentNode.removeChild(link)
//   }
//
//   function replaceId(arr, oldId, newId) {
//     for (let i = 0; i < arr.length; i++) {
//       if (Array.isArray(arr[i])) {
//         replaceId(arr[i], oldId, newId) // Recurse into nested arrays
//       } else if (typeof arr[i] === 'object' && arr[i] !== null) {
//         replaceId(Object.values(arr[i]), oldId, newId) // Recurse into nested objects
//       } else if (arr[i] === oldId) {
//         arr[i] = newId // Replace the 'id' within root and nested arrays
//       }
//     }
//     return arr
//   }
// }

export const fetchChartListBySourceId = async (sourceId: string) => {
  const uri = `${Endpoints.Wizard}/${sourceId}/Charts`
  const response = await fetch(uri)
  return normalizeKeys(response.data)
}

export const useWizardUpload = () => {
  const [decoded, setDecoded] = useState(null)
  const [uploadError, setUploadError] = useState<string | null>(null)
  const [uploading, setUploading] = useState(false)

  const {
    productsStore: { currentProduct },
  } = rootStore

  const handleUpload = useCallback(
    async ({ file, blueprintId, planId }) => {
      try {
        setUploading(true)
        const arrayBuffer = await file
          ?.arrayBuffer()
          .then(arrayBuffer => arrayBuffer)

        const bufferContent = [
          uuidv4(),
          planId,
          currentProduct,
          blueprintId,
          file.name,
          new Uint8Array(arrayBuffer),
        ]

        // Convert formData to MessagePack
        const buffer = msgpack.encode(bufferContent)
        const response = await post(`${Endpoints.Wizard}`, buffer, {
          responseType: 'arraybuffer',
          headers: {
            'Content-Type': 'application/x-msgpack',
          },
        })

        const array = new Uint8Array(response.data) as Buffer

        const decoded = msgpack.decode(array)
        setDecoded(decoded)
        return decoded
      } catch (e) {
        setUploadError(parseError(e))
      } finally {
        setUploading(false)
      }
    },
    [currentProduct, setDecoded, setUploadError],
  )
  return {
    handleUpload,
    decoded,
    uploadError,
    setUploadError,
    uploading,
  }
}

const parseError = e => {
  return msgpack.decode((e as AxiosError).response?.data as Buffer)
}

/**
 * Fetch issue summary
 * @param sourceId
 */
export async function fetchIssueSummary(sourceId) {
  const uri = `${Endpoints.Wizard}/${sourceId}/IssueSummary`
  const response = await fetch(uri)

  return normalizeKeys(response.data)
}
